import {
    IFormField,
    FormSection
} from "../../shared/components/web-form/web-form.objects";

import {
    WebForm
} from "../../shared/components/web-form/web-form";
import {
    DropdownInputField,
    DropdownInputOptions
} from "../../shared/components/web-form/form-field/dropdown-input";

import {
    DateInputField,
    DateInputOptions
} from "../../shared/components/web-form/form-field/date-input";

import {
    FileUploadInputField,
    FileUploadInputOptions
} from "../../shared/components/web-form/form-field/file-upload";

import {
    TextInputField,
    TextInputOptions,
    TextInputType
} from "../../shared/components/web-form/form-field/text-input";

import {
    CabHubConnectionEntity,
    CabHubTrackingPageVm
} from "./cab-hub-tracking.entities";
import {

    IEditController
} from "../../shared/components/edit-table/edit-table";

import _ from "lodash";
declare const page: {
    connectionTable: {
        editTable: {
            currentTargetItem?:
            CabHubConnectionEntity;
        };
    };
};
// Admin: add connection form

export class CabHubConnectionFormController {
    private readonly vm:
        CabHubTrackingPageVm;
    private isEditMode = false;
    //private readonly activeStatusId = 1;

    private readonly formContainer =
        "#cab-hub-connection-form";

    private readonly connectionModal =
        "#cab-hub-connection-modal";

    private readonly connectionModalTitle =
        "#cab-hub-connection-modal-title";

    private readonly connectionError =
        "#cab-hub-connection-error";

    private readonly saveConnectionButton =
        "#cab-hub-save-connection-button";


    private readonly cabMemberField:
        DropdownInputField;

    private readonly hubField:
        DropdownInputField;

    private readonly statusField:
        DropdownInputField;


    private readonly startDateField:
        DateInputField;

    private readonly endDateField:
        DateInputField;

    private readonly agreementUploadField:
        FileUploadInputField;

    private readonly notesField:
        TextInputField;

    private readonly fields:
        IFormField[];

    private readonly webForm:
        WebForm;
    // CabHubConnectionEditController
    
    constructor(vm: CabHubTrackingPageVm,
        private readonly saveBaseRoute:
            string = window.location.pathname) {
        this.vm = vm;

        this.cabMemberField =
            new DropdownInputField(
                "CabMemberUserId",
                "cab-hub-cab-member",
                "CAB Member",
                "",
                true,
                new DropdownInputOptions(
                    "pl-cab-member",
                    false,
                    true
                )
            );
        this.hubField =
            new DropdownInputField(
                "HubId",
                "cab-hub-hub",
                "Hub",
                "",
                true,
                new DropdownInputOptions(
                    "pl-hub",
                    false,
                    true
                )
            );
        this.statusField =
            new DropdownInputField(
                "StatusId",
                "cab-hub-connection-form-status",
                "Status",
                "",
                true,
                new DropdownInputOptions(
                    "pl-connection-status",
                    false,
                    true,
                    false
                )
            );
        this.startDateField =
            new DateInputField(
                "StartDate",
                "cab-hub-start-date",
                "Start Date",
                "",
                true,
                new DateInputOptions()
            );

        this.endDateField =
            new DateInputField(
                "EndDate",
                "cab-hub-end-date",
                "End Date",
                "",
                false,
                new DateInputOptions()
            );
        this.agreementUploadField =
            new FileUploadInputField(
                "AgreementUploadId",
                "cab-hub-agreement-upload",
                "Agreement / Contract Upload",
                "",
                false,
                new FileUploadInputOptions(
                    "cab-hub-uploads",
                    false,
                    true
                )
            );

        this.notesField =
            new TextInputField(
                "AdminNotes",
                "cab-hub-notes",
                "Notes",
                "Add internal notes about the relationship, status, documentation, or follow-up items.",
                false,
                new TextInputOptions(
                    TextInputType.Any,
                    -99,
                    -99,
                    false,
                    4
                )
            );

        this.fields = [
            this.cabMemberField,
            this.hubField,
            this.statusField,
            this.startDateField,
            this.endDateField,
            this.agreementUploadField,
            this.notesField
        ];

        const connectionSection =
            new FormSection({
                sectionId:
                    "cab-hub-connection-section",
                 

                displayName:
                    "Connection Information",

                formFields:
                    this.fields
            });

        const defaultConnection =
            this.getDefaultConnection();

        this.webForm =
            new WebForm({
                formSections: [
                    connectionSection
                ],

                saveRoute:
                    this.saveBaseRoute +
                    "?handler=AddConnection",

                defaultItem:
                    defaultConnection
            });

    
    }

   public initialize(): void {
       if (
           this.vm.Scope !==
           "admin"
       ) {
           return;
       }
        this.renderForm();

      
        this.webForm.initialize(
            this.vm.PickLists ?? []
        );

        this.wireAdminEvents();
    }
    private renderField(
        field: IFormField
    ): string {

        if (
            field ===
            this.agreementUploadField
        ) {
            return `
            <label class="label-title ${field.isRequired ? "required" : ""}">
                ${field.displayName}
            </label>

            ${field.description
                    ? `<p class="form-text">${field.description}</p>`
                    : ""
                }

            <div id="${field.fieldId}"
                 class="file-upload-container">
            </div>
        `;
        }

        return field.generateHtml();
    }
    private renderForm(): void {
        let html = "";

        this.webForm.formSections.forEach(
            section => {
                html += `
                <section id="${section.sectionId}"
                         class="pt-0 pb-0">
                      

                    ${section.displayName
                        ? `
                                <h6 class="mb-3">
                                    ${section.displayName}
                                </h6>
                              `
                        : ""
                    }

                    <div class="form-row">
            `;

                section.formFields.forEach(
                    field => {
                        html += `
            <div class="form-group col-12">
                ${this.renderField(field)}
            </div>
        `;
                    }
                );
                html += `
                    </div>
                </section>
            `;
            }
        );

        $(this.formContainer)
            .empty()
            .html(html);
    }

    private setRelationshipFieldsReadOnly(
        isReadOnly:
            boolean
    ): void {

        $("#cab-hub-cab-member, #cab-hub-hub")
            .prop(
                "disabled",
                isReadOnly
            )
            .selectpicker(
                "refresh"
            );

        $("#cab-hub-cab-member, #cab-hub-hub")
            .siblings(
                ".dropdown-toggle"
            )
            .prop(
                "disabled",
                isReadOnly
            );
    }
    private wireAdminEvents(): void {
        $(this.saveConnectionButton)
            .off(
                "click.addCabHubConnection"
            )
            .on(
                "click.addCabHubConnection",
                async () => {
                    await this.handleSaveConnection();
                }
            );
    }

    public openAddConnectionModal(): void {
        this.isEditMode =
            false;

        this.resetAddForm();

        this.setRelationshipFieldsReadOnly(
            false
        );

        $(this.connectionModalTitle)
            .text(
                "Add CAB–Hub Connection"
            );

        $(this.connectionModal)
            .modal("show");
    }
    // CabHubConnectionFormController
    public openEditConnectionModal(
        connection:
            CabHubConnectionEntity
    ): void {
        this.isEditMode =
            true;

        this.webForm.currentItem =
            connection;

        this.fields.forEach(field => {
            field.prepopulate([
                connection
            ]);

            field.resetValidDisplay();
        });

        this.setRelationshipFieldsReadOnly(
            true
        );

        this.hideError();

        $(this.connectionModalTitle)
            .text(
                "Edit CAB–Hub Connection"
            );

        $(this.connectionModal)
            .modal("show");
    }

    private resetAddForm(): void {
        const defaultConnection =
            this.getDefaultConnection();

        this.webForm.currentItem =
            defaultConnection;

        // Rebuild and clear the reused upload field.
        this.agreementUploadField
            .initialize();

        this.fields.forEach(field => {
            field.prepopulate([
                defaultConnection
            ]);

            field.resetValidDisplay();
        });

        this.hideError();
    }

    private getDefaultConnection():
        CabHubConnectionEntity {

        const connection =
            new CabHubConnectionEntity();

        connection.Id = 0;

        connection.CabMemberUserId = 0;
        connection.HubId = 0;

        connection.StatusId =
            1;

        connection.StartDate =
            this.getTodayInputValue();

        connection.EndDate =
            undefined;

        connection.AgreementUploadId =
            "";

        connection.AdminNotes =
            "";

        return connection;
    }
    private connectionAlreadyExists():
        boolean {

        const cabMemberUserId =
            Number(
                this.cabMemberField
                    .getValue()
            );

        const hubId =
            Number(
                this.hubField
                    .getValue()
            );

        return (
            this.vm.Connections ?? []
        )
            .some(
                connection =>
                    connection.CabMemberUserId ===
                    cabMemberUserId &&
                    connection.HubId ===
                    hubId
            );
    }

    private validateForm(): boolean {
        let isValid = true;

        this.fields.forEach(field => {
            const fieldIsValid =
                field.checkValid();

            field.displayValid(
                fieldIsValid
            );

            if (!fieldIsValid) {
                isValid = false;
            }
        });

        return isValid;
    }

    private async handleSaveConnection():
        Promise<void> {

        if (!this.validateForm()) {
            this.showError(
                "Please complete all required fields."
            );

            return;
        }

        if (
            !this.isEditMode &&
            this.connectionAlreadyExists()
        ) {
            this.showError(
                "A connection already exists for this CAB member and Hub."
            );

            return;
        }

        this.hideError();

        const $saveButton =
            $(this.saveConnectionButton);

        try {
            $saveButton
                .prop("disabled", true)
                .text("Saving...");

            this.webForm.saveRoute =
                this.saveBaseRoute +
                (
                    this.isEditMode
                        ? "?handler=UpdateConnection"
                        : "?handler=AddConnection"
                );

            const result = await this.webForm.saveForm();
            if (!result) {
                return;
            }

            $(this.connectionModal)
                .modal("hide");

            window.location.reload();
        }
        catch (error) {
            console.error(
                "Unable to save connection:",
                error
            );

            this.showError(
                "The connection could not be saved."
            );
        }
        finally {
            $saveButton
                .prop("disabled", false)
                .text("Save Connection");
        }
    }

    private getTodayInputValue(): string {
        const today =
            new Date();

        const year =
            today.getFullYear();

        const month =
            String(
                today.getMonth() + 1
            ).padStart(2, "0");

        const day =
            String(
                today.getDate()
            ).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    private showError(
        message: string
    ): void {
        $(this.connectionError)
            .text(message)
            .removeClass("d-none");
    }

    private hideError(): void {
        $(this.connectionError)
            .empty()
            .addClass("d-none");
    }

}
//Admin : edit


export class CabHubConnectionEditController
    implements IEditController {

    constructor(
        private readonly formController:
            CabHubConnectionFormController
    ) {
    }
    // CabHubConnectionEditController
    public openConnection(
        connection:
            CabHubConnectionEntity
    ): void {
        this.formController
            .openEditConnectionModal(
                connection
            );
    }
    public getEditMenu(): string {
        return `
            <button type="button"
                    class="dropdown-item"
                    onclick="
                        page.connectionEdit
                            .editCurrentConnection()
                    ">
                Edit Connection
            </button>
        `;
    }

    public editCurrentConnection(): void {
        const connection =
            page.connectionTable
                .editTable
                .currentTargetItem as
            CabHubConnectionEntity;

        if (!connection) {
            console.error(
                "No CAB–Hub connection is selected."
            );

            return;
        }

        this.formController
            .openEditConnectionModal(
                connection
            );
    }

    public async saveItems(
        items: any[],
        isAdd: boolean
    ): Promise<void> {
        return;
    }
}